// extracted by mini-css-extract-plugin
module.exports = {"tab":"CompetitionTabs_tab__xfpCz"};